import { Injectable } from '@angular/core';
import { ImageCompressionServicesModule } from './image-compression-services.module';
import { ImageCompressionLogicService, ImageOptions } from './image-compression-logic.service';
import { Observable, EMPTY } from 'rxjs';
import { LoggerProvider, Logger } from 'src/app/core/logger';
import { catchError } from 'rxjs/operators';

@Injectable({
	providedIn: ImageCompressionServicesModule
})
export class CompressionMediatorService {

	private logger: Logger;

	constructor(
		private imageCompression: ImageCompressionLogicService,
		private loggerProvider: LoggerProvider
	) {
		this.logger = this.loggerProvider.create('Blog image compression service');
	}

	public compressImage(imageFile: File, destinationResolution: ImageOptions): Observable<File> {
		return this.imageCompression.compressImageToRatio(imageFile, destinationResolution).pipe(
			catchError(err => {
				this.logger.info('Error on image compression:' + err);
				return EMPTY;
			})
		);
	}

	public compressImageBase64(imageFile: File, destinationResolution: ImageOptions): Observable<string> {
		return this.imageCompression.compressImageToRatioBase64(imageFile, destinationResolution).pipe(
			catchError(err => {
				this.logger.info('Error on image compression:' + err);
				return EMPTY;
			})
		);
	}


}
